export const INFINITY_MAGIC_STRING = '8f879a9430f016809244zach'

export const infintySerializeReplacer = (_key: string, value: any) => {
  if (value === null) {
    return 'null'
  }
  if (value === Infinity) {
    return INFINITY_MAGIC_STRING
  }
  return value
}

export const infintyDeserializeReplacer = (_key: string, value: any) => {
  if (value === INFINITY_MAGIC_STRING) {
    return Infinity
  }
  if (value === 'null') {
    return null
  }
  return value
}

export const serializeInfinity = (data: any) =>
  JSON.parse(JSON.stringify(data, infintySerializeReplacer))
